var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"imageEditorApp"},[_c('tui-image-editor',{ref:"tuiImageEditor",attrs:{"include-ui":_vm.useDefaultUI,"options":_vm.options},on:{"addText":_vm.onAddText,"objectMoved":_vm.onObjectMoved}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }